// extracted by mini-css-extract-plugin
export default {"select_label_table":"dropdownGroup_select_label_table__YCiw1","table_select":"dropdownGroup_table_select__LbK+5"};